/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Modal from 'apollo-react/components/Modal';
import Table from 'apollo-react/components/Table';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { columns } from './columns';
import { useTranslation } from '../../../../../../custom-hooks/useTranslation';
import { CHART_DATA_EDITOR } from '../../../../../constants/editor.constants';
import ExpandableComponent from '../ExpandableComponent';
import { TABLE_STYLES } from '../styles';

const useStyles = makeStyles({
  ...TABLE_STYLES,
  modal: {
    minWidth: '70%',
  },
});

const ClusterDataModal = ({ open, currentClusterData, handleClose, setCurrentClusterData }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [rows, setRows] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentAccessor, setCurrentAccessor] = useState(null);

  useEffect(() => {
    if (open) {
      setRows(_.cloneDeep(currentClusterData));
      setExpandedRow(null);
      setCurrentAccessor(null);
    }
  }, [open]);

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      {
        id: uuidv4(),
        type: 'formula',
        label: '',
        value: '',
      },
    ]);
  };

  const deleteRow = (id) => {
    setRows((prev) => prev.filter((item) => item.id !== id));
  };

  const editRow = (id, accessor, value) => {
    setRows((prev) => prev.map((item) => (item.id === id ? { ...item, [accessor]: value } : item)));
  };

  const toggleRow = (id, accessor) => {
    setExpandedRow((prev) => (prev === id && currentAccessor === accessor ? null : id));
    setCurrentAccessor(accessor);
  };

  const handleSave = () => {
    setCurrentClusterData(rows);
    handleClose();
  };

  const CustomHeader = () => (
    <Button variant="text" size="small" onMouseDown={addRow}>
      {translateString('Add Cluster Value')}
    </Button>
  );

  return (
    <Modal
      open={open}
      className={classes.modal}
      onClose={handleClose}
      title={`${CHART_DATA_EDITOR} (Cluster Data)`}
      buttonProps={[
        { label: translateString('Cancel'), onClick: handleClose, 'ui-ta': 'CancelBtn' },
        { label: translateString('Save'), onClick: handleSave, 'ui-ta': 'SaveBtn' },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <div className={classes.root}>
        <Table
          title="Cluster Data"
          columns={columns}
          rows={rows.map((row) => ({
            ...row,
            key: row.id,
            expanded: expandedRow === row.id,
            currentAccessor,
            deleteRow,
            editRow,
            toggleRow,
          }))}
          hidePagination
          CustomHeader={CustomHeader}
          ExpandableComponent={ExpandableComponent}
        />
      </div>
    </Modal>
  );
};

export default ClusterDataModal;
